export default __webpack_public_path__ + "slices/main/assets/public/media/officevibe-logo.4b29d3ce449464d7ea8410b0c9a5d06b.png";